import gql from 'graphql-tag';

export default gql`
    mutation UpdateAssetPlans($input: UpdateAssetPlansInput) {
        updateAssetPlans(input: $input) {
            errors
        }
    }
`;
